export const API_KEY = process.env.API_KEY;
export const API_KEY_HEADER = 'api-key';
